var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: {
                label: "奖励分组",
                prop: "reward_group_id",
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择奖励分组"
                  },
                  model: {
                    value: _vm.formData.reward_group_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "reward_group_id", $$v)
                    },
                    expression: "formData.reward_group_id"
                  }
                },
                _vm._l(_vm.rewardList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: {
                label: "赛区",
                prop: "division_id",
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择赛区"
                  },
                  model: {
                    value: _vm.formData.division_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "division_id", $$v)
                    },
                    expression: "formData.division_id"
                  }
                },
                _vm._l(_vm.divisionList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "VIP等级", prop: "vip_level_required" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.formData.vip_level_required,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "vip_level_required", $$v)
                  },
                  expression: "formData.vip_level_required"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "设备激活数量", prop: "capacity" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.formData.capacity,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "capacity", $$v)
                  },
                  expression: "formData.capacity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "开始时间", prop: "start_time" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "popper-class": "no-atTheMoment",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "日期"
                },
                model: {
                  value: _vm.formData.start_time,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "start_time", $$v)
                  },
                  expression: "formData.start_time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "结束时间", prop: "end_time" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "popper-class": "no-atTheMoment",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "日期"
                },
                model: {
                  value: _vm.formData.end_time,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "end_time", $$v)
                  },
                  expression: "formData.end_time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { label: "赛事描述", prop: "description" }
            },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "请输入",
                  type: "textarea"
                },
                model: {
                  value: _vm.formData.description,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "description", $$v)
                  },
                  expression: "formData.description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }